<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
  variant?: 'primary' | 'secondary' | 'ghost';
  href?: string;
  type?: 'button' | 'submit' | 'reset';
}>();

const tag = computed(() => (props.href ? 'a' : 'button'));
</script>

<template>
  <component
    :is="tag"
    :href="href"
    :type="tag === 'button' ? type || 'button' : undefined"
    class="babel-button"
    :class="[
      variant === 'secondary' ? 'babel-button--secondary' :
      variant === 'ghost' ? 'babel-button--ghost' :
      'babel-button--primary'
    ]"
  >
    <slot />
  </component>
</template>
